module.exports = __webpack_public_path__ + "experience/innovation/images/investigate-terrain-texture.a217281.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/app-experience/Experience/images/investigate-terrain-texture.png
// module id = pD9k
// module chunks = 1